import type { GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId200 } from '@fukuri-admins/apis/client/gen/model';
import type { ClientContractTermDetailHeaderPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof ClientContractTermDetailHeaderPresentation>;

type Args = {
  /** API レスポンス（useFetch の data をそのまま受け取る） */
  data: GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId200;
};

type IConvertToPresentationProps = (args: Args) => PresentationProps;

/**
 * 企業契約期間データを ClientContractTermDetailHeader の Presentation Props に変換する
 *
 * - data.client_contract から単一の契約期間を受け取る
 */
export const convertToPresentationProps: IConvertToPresentationProps = ({ data }) => {
  const contractTerm = data.client_contract;

  return {
    clientName: contractTerm.client.name,
  };
};
